import { ClientAdminRequest, TermsAndConditionsModel } from './../types/index';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { CacheTags } from 'types';
import { ClientResponse } from './bindings/ClientResponse';
import { OdinBaseQuery } from './core';
import { getCacheTagType } from 'core';
import { TransactionRoutingSettingsModel } from './bindings/TransactionRoutingSettingsModel';

export const clientsApi = createApi({
  reducerPath: 'clients',
  baseQuery: OdinBaseQuery,
  tagTypes: [CacheTags.client],
  endpoints: (builder) => ({
    fetchClient: builder.query<ClientResponse, string>({
      query: (payload) => ({
        url: `/api/ca/clients/${payload}`,
        method: 'GET',
      }),
      providesTags: (payload) => [
        {
          type: CacheTags.client,
          id: payload?.id,
        },
      ],
    }),
    fetchTermsAndConditions: builder.query<
      TermsAndConditionsModel,
      ClientAdminRequest
    >({
      query: (payload) => ({
        url: `/api/terms-and-conditions`,
        method: 'GET',
        params: payload,
      }),
    }),
    updateTermsAndConditions: builder.mutation<any, TermsAndConditionsModel>({
      query: (payload) => ({
        url: `/api/terms-and-conditions`,
        method: 'PUT',
        body: payload,
        params: {
          clientId: payload?.clientId ?? 0,
        },
      }),
    }),
    saveApproverSettings: builder.mutation<
      any,
      TransactionRoutingSettingsModel
    >({
      query: (payload) => ({
        url: `/api/ca/clients/${payload.clientId}/approvers`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (result, err, req) => [
        { type: CacheTags.client, id: req.clientId },
        { type: getCacheTagType(req.transactionType) },
      ],
    }),
  }),
});

export const {
  useFetchClientQuery,
  useSaveApproverSettingsMutation,
  useFetchTermsAndConditionsQuery,
  useUpdateTermsAndConditionsMutation,
} = clientsApi;
